
import React, { useState } from "react";
import './JobPostingForm.css';

const Step1 = ({ nextStep, setFormData }) => {
  const [jobDetails, setJobDetails] = useState({
    title: "",
    description: "",
    employmentType: "",
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!jobDetails.title.trim()) {
      newErrors.title = "Job title is required";
    }
    if (!jobDetails.description.trim()) {
      newErrors.description = "Description is required";
    }
    if (!jobDetails.employmentType) {
      newErrors.employmentType = "Please select employment type";
    }
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setJobDetails((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleNext = (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setFormData((prev) => ({ ...prev, jobDetails }));
      nextStep();
    }
  };

  return (
    <form onSubmit={handleNext} className="form-step-content">
      <div className="form-fields-grid">
        <div className="form-group">
          <label htmlFor="title" className="form-label">
            Job Title
            <span className="required-star">*</span>
          </label>
          <input
            type="text"
            id="title"
            name="title"
            value={jobDetails.title}
            onChange={handleChange}
            placeholder="e.g., Software Engineer"
            className={`form-control ${errors.title ? 'is-invalid' : ''}`}
          />
          {errors.title && <div className="invalid-feedback">{errors.title}</div>}
          <div className="form-hint">Enter a clear and descriptive job title</div>
        </div>

        <div className="form-group">
          <label htmlFor="description" className="form-label">
            Job Description
            <span className="required-star">*</span>
          </label>
          <textarea
            id="description"
            name="description"
            value={jobDetails.description}
            onChange={handleChange}
            placeholder="Describe the job responsibilities, requirements, and expectations..."
            className={`form-control ${errors.description ? 'is-invalid' : ''}`}
            rows="6"
          />
          {errors.description && <div className="invalid-feedback">{errors.description}</div>}
          <div className="form-hint">
            <span className="char-count">{jobDetails.description.length}/2000 characters</span>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="employmentType" className="form-label">
            Employment Type
            <span className="required-star">*</span>
          </label>
          <select
            id="employmentType"
            name="employmentType"
            value={jobDetails.employmentType}
            onChange={handleChange}
            className={`form-control ${errors.employmentType ? 'is-invalid' : ''}`}
          >
            <option value="">Select employment type</option>
            <option value="Full-time">Full-time</option>
            <option value="Part-time">Part-time</option>
            <option value="Contract">Contract</option>
            <option value="Temporary">Temporary</option>
            <option value="Internship">Internship</option>
          </select>
          {errors.employmentType && <div className="invalid-feedback">{errors.employmentType}</div>}
        </div>
      </div>

      
    </form>
  );
};

export default Step1;